import type { Map as LeafletMap } from 'leaflet';

const REGISTRY_KEY = '__atlas_leaflet_map__' as const;

export const DRAWINGS_PANE_NAME = 'atlas-drawings-pane' as const;
export const DRAWINGS_PANE_Z_INDEX = 550;

export function createDrawingsPane(map: LeafletMap): void {
  if (map.getPane(DRAWINGS_PANE_NAME)) return;

  const pane = map.createPane(DRAWINGS_PANE_NAME);
  pane.style.zIndex = String(DRAWINGS_PANE_Z_INDEX);
}

export const DRAWING_HIT_STROKE_CLASS_NAME = "atlas-drawing-hit-stroke";

export function registerMapInstance(map: LeafletMap): void {
  (window as any)[REGISTRY_KEY] = map;
}

export function unregisterMapInstance(): void {
  delete (window as any)[REGISTRY_KEY];
}

export function getMapInstance(): LeafletMap | null {
  return (window as any)[REGISTRY_KEY] ?? null;
}
